module.exports = __webpack_public_path__ + "static/kasikorn-6ef2acb904eace18cecbea173eff1e0e.svg";